import React from 'react';
import {IndexLink, browserHistory}  from 'react-router';

let Footer  = React.createClass({


  render : function(){

    return (
      <div className= "footer">
        <div className="jumbotron">
          <div className="row footer-margin">
            <div className="columns logo-social-div">
              <a href="/" target="blank"><img className="footer_logo" src="https://d2hfzg3ugxeze1.cloudfront.net/logo/GreenPlayologo%403x.png" alt="logo"/></a>
              <div className="social">
                <ul className="social-icons">
                  <li> <a href="https://www.facebook.com/PlayoApp/" target="blank"><img src="https://d2hfzg3ugxeze1.cloudfront.net/venues-listing/facebook.svg" alt="playo-facebook"/></a></li>
                  <li> <a href="https://twitter.com/playoApp" target="blank"><img src="https://d2hfzg3ugxeze1.cloudfront.net/venues-listing/twitter.svg" alt="playo-twitter"/></a></li>
                  <li> <a href="https://in.pinterest.com/playoapp/?etslf=2309&eq=playo%20"  target="blank"><img src="https://d2hfzg3ugxeze1.cloudfront.net/venues-listing/pin.svg" alt="playo-pinterest"/></a> </li>
                  <li> <a href="https://instagram.com/playoapp/"  target="blank"><img src="https://d2hfzg3ugxeze1.cloudfront.net/venues-listing/insta.svg" alt="playo-instagram"/></a> </li>
                  <li> <a href="https://www.linkedin.com/company/playo"  target="blank"><img src="https://d2hfzg3ugxeze1.cloudfront.net/venues-listing/linkedin.svg" alt="playo-linkedin"/></a> </li>
                </ul>
              </div>

            </div>
            <div className="columns footer-link-div">
              <div className="row">
                <div className="columns company-links company">
                  <div className="footer-content footer-float-left">
                    <span> Company </span>
                    <ul>
                      <li><a href="/" className="link" target="blank">App</a></li>
                      <li><a href="/about" className="link" target="blank">About Us</a></li>
                      <li><a href="/about" className="link" target="blank" >Team</a></li>
                      <li><a href="/about" className="link"  target="blank" >Reviews</a></li>

                    </ul>
                  </div>

                </div>
                <div className="columns company-links company">
                  <div className="footer-content ">
                    <span> Business </span>
                    <ul>
                      <li><a href="/about" className="link" target="blank">Contact Us</a></li>
                      <li><a href="/about"className="link" target="blank" >Partner With Us</a></li>
                      <li><a href="https://playo.co/privacy" target="blank">Privacy & Terms</a></li>
                    </ul>
                  </div>

                </div>
                <div className="columns company-links company hideOnMobile">
                  <div className="footer-content">
                    <span> Social Links </span>
                    <ul>
                      <li><a href="https://www.facebook.com/PlayoApp/" target="blank">Facebook</a></li>
                      <li><a href="https://twitter.com/playoApp"  target="blank">Twitter</a></li>
                      <li><a href="https://in.pinterest.com/playoapp/?etslf=2309&eq=playo%20"  target="blank">pinterest</a></li>
                      <li><a href="https://instagram.com/playoapp/"  target="blank">Instagram</a></li>
                      <li><a href="https://www.linkedin.com/company/playo"  target="blank">Linkedin</a></li>

                    </ul>
                  </div>

                </div>

              </div>

            </div>
          </div>
          <div className="row copyright">
            <div className="col-md-6 col-sm-8 col-xs-12">
              &copy;	2017 TechMash Solutions. All Rights Reserved.
            </div>
          </div>
        </div>
      </div>
    );
  }


});

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/footer.js